export default "__VITE_ASSET__pMEJfRh8__"